export default __webpack_public_path__ + "static/media/bag-outline.479e66b4.svg";